module.exports = __webpack_public_path__ + "static/media/PESVA_MENU-normal.85dcb82e.png";